(() => {
  const config = JSON.parse(document.querySelector('#bc-vip-config')?.textContent || '{}');
  const text = config.cart || {};
  const dialog = document.querySelector('#bc-cart');
  const lines = document.querySelector('#bc-cart-lines');
  const total = document.querySelector('#bc-cart-total');
  const form = document.querySelector('#bc-product-form');
  const vip = document.querySelector('#bc-vip-checkbox');
  const status = document.querySelector('#bc-vip-status');
  const member = form?.dataset.vipMember === 'true';
  const money = value => new Intl.NumberFormat('it-IT', {style:'currency', currency:'EUR'}).format(value / 100);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'}[char]));
  const root = window.Shopify?.routes?.root || '/';
  const membership = item => String(item.variant_id) === String(config.variant) && String(item.selling_plan_allocation?.selling_plan?.id) === String(config.plan);
  const vipLine = item => String(item.variant_id) === String(config.variant);
  let busy = false;
  let cartHasItems = false;
  let vipTouched = false;
  let pending = Promise.resolve();
  async function request(path, body) {
    const response = await fetch(root + path, body ? {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify(body)} : {headers:{Accept:'application/json'}});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || config.error);
    return data;
  }
  function syncPrices() {
    document.querySelectorAll('[data-bc-price]').forEach(price => {price.textContent = money(Number(vip?.checked || member ? price.dataset.vipPrice : price.dataset.basePrice));});
  }
  function syncAvailability() {
    const selected = form?.querySelector('[name=id]:checked')?.value;
    document.querySelectorAll('[data-stock-for]').forEach(node => {node.hidden = node.dataset.stockFor !== selected;});
  }
  form?.addEventListener('change', event => {if (event.target.name === 'id') syncAvailability();});
  syncAvailability();
  function setBusy(value) {
    busy = value;
    if (form) form.querySelector('[type=submit]').disabled = value;
    if (vip) vip.disabled = value || member;
    dialog?.querySelectorAll('[data-remove], [data-key], [data-step-key]').forEach(control => {control.disabled = value;});
    const checkout = dialog?.querySelector('button[name=checkout]');
    if (checkout) checkout.disabled = value || !cartHasItems;
  }
  function lineMarkup(item) {
    if (vipLine(item)) return `<article class="bc-cart-membership bc-cart-membership-product"><div class="bc-vip-card-main"><span class="bc-vip-card-icon" aria-hidden="true">✦</span><strong>VIP CLUB</strong></div><button data-remove="${escape(item.key)}" type="button" aria-label="${escape(config.remove)}"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M4 7h16M9 3h6l1 4H8l1-4ZM6 7l1 14h10l1-14M10 10v8M14 10v8"/></svg></button><details class="bc-vip-card-terms"><summary style="cursor:pointer;list-style:none">Disdici quando vuoi · <u>Più informazioni</u></summary><p>${escape(item.properties?.['Condizioni VIP'] || config.recurring)}</p></details></article>`;
    const plan = item.selling_plan_allocation?.selling_plan?.name;
    const saved = item.original_line_price - item.final_line_price;
    const properties = Object.entries(item.properties || {}).filter(([key,value]) => !key.startsWith('_') && value).map(([key,value]) => `<p class="bc-cart-variant">${escape(key)}: ${escape(value)}</p>`).join('');
    return `<article class="bc-cart-line">${item.image ? `<a href="${escape(item.url)}" tabindex="-1" aria-hidden="true"><img src="${escape(item.image)}" alt="" width="90" height="100"></a>` : '<div></div>'}<div class="bc-cart-line-info"><div class="bc-cart-line-title"><h3><a href="${escape(item.url)}">${escape(item.product_title)}</a></h3><button data-remove="${escape(item.key)}" type="button" aria-label="${escape(text.remove)} ${escape(item.product_title)}"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M4 7h16M9 3h6l1 4H8l1-4ZM6 7l1 14h10l1-14M10 10v8M14 10v8"/></svg></button></div>${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="bc-cart-variant">${escape(item.variant_title)}</p>` : ''}${properties}${plan ? `<p class="bc-cart-plan">${escape(plan)}</p>` : ''}<div class="bc-cart-prices">${saved > 0 ? `<del>${money(item.original_line_price)}</del>` : ''}<strong>${money(item.final_line_price)}</strong>${saved > 0 ? `<span>${escape(text.saved)} ${money(saved)}</span>` : ''}</div><div class="bc-cart-line-actions"><div class="bc-cart-quantity"><button data-step-key="${escape(item.key)}" data-step-quantity="${item.quantity - 1}" type="button" aria-label="${escape(text.decrease)}">−</button><input aria-label="${escape(text.quantity)} ${escape(item.product_title)} ${escape(item.variant_title)}" type="number" min="0" value="${item.quantity}" data-key="${escape(item.key)}"><button data-step-key="${escape(item.key)}" data-step-quantity="${item.quantity + 1}" type="button" aria-label="${escape(text.increase)}">+</button></div>${saved > 0 ? `<span class="bc-cart-badge">${escape(text.applied)}</span>` : ''}</div></div></article>`;
  }
  async function renderCart() {
    const cart = await request('cart.js');
    cartHasItems = cart.items.length > 0;
    const count = document.querySelector('#bc-cart-count');
    if (count) count.textContent = cart.items.filter(item => !vipLine(item)).reduce((sum,item) => sum + item.quantity,0);
    if (total) total.textContent = money(cart.total_price);
    const products = cart.items.filter(item => !vipLine(item));
    if (lines) lines.innerHTML = products.length ? products.map(lineMarkup).join('') + cart.items.filter(vipLine).map(lineMarkup).join('') : `<p class="bc-cart-empty">${escape(text.empty)}</p>`;
    const terms = document.querySelector('#bc-cart-membership');
    if (terms) terms.innerHTML = '';
    dialog?.querySelectorAll('[data-checkout-total]').forEach(node => {node.textContent = money(cart.total_price);});
    if (dialog) dialog.querySelector('[name=checkout]').disabled = busy || !cart.items.length;
    return cart;
  }
  async function removePendingMembership(cart) {
    for (const item of cart.items.filter(membership)) await request('cart/change.js', {id:item.key, quantity:0});
  }
  document.querySelectorAll('.bc-cart-trigger').forEach(link => link.addEventListener('click', async event => {
    event.preventDefault();
    try {await pending; await renderCart(); dialog.showModal();} catch {location.href = link.href;}
  }));
  document.querySelectorAll('[data-close-cart]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog?.addEventListener('click', event => {if (event.target === dialog && event.clientX < dialog.getBoundingClientRect().left) dialog.close();});
  async function change(key, quantity) {
    if (busy) return;
    setBusy(true);
    const error = document.querySelector('#bc-cart-error');
    if (error) error.textContent = '';
    try {
      const before = await request('cart.js');
      const removedVip = before.items.some(item => item.key === key && membership(item)) && quantity === 0;
      await request('cart/change.js', {id:key, quantity});
      if (removedVip && vip && !member) {vip.checked = false; vipTouched = true; syncPrices();}
      await renderCart();
    } catch (failure) {if (error) error.textContent = failure.message;} finally {setBusy(false);}
  }
  lines?.addEventListener('change', event => {if (event.target.matches('[data-key]')) change(event.target.dataset.key, Math.max(0, Number(event.target.value) || 0));});
  dialog?.addEventListener('click', event => {
    const remove = event.target.closest('[data-remove]');
    const step = event.target.closest('[data-step-key]');
    if (remove) change(remove.dataset.remove,0);
    if (step) change(step.dataset.stepKey,Math.max(0,Number(step.dataset.stepQuantity)));
  });
  document.querySelectorAll('[data-page-step]').forEach(button => button.addEventListener('click', () => {
    const input = button.parentElement.querySelector('input');
    input.value = Math.max(0,Number(input.value) + Number(button.dataset.pageStep));
    input.form.requestSubmit(input.form.querySelector('[name=update]'));
  }));
  vip?.addEventListener('change', () => {
    vipTouched = true;
    syncPrices();
    if (member) return;
    const selectedVip = vip.checked;
    setBusy(true);
    status.textContent = '';
    pending = pending.then(async () => {
      try {
        const cart = await request('cart.js');
        if (selectedVip) {
          const eligibleVariants = new Set(Array.from(form.querySelectorAll('[name="id"]')).map(input => String(input.value)));
          if (cart.items.some(item => eligibleVariants.has(String(item.variant_id))) && !cart.items.some(membership)) {
            await request('cart/add.js', {items:[{id:config.variant, quantity:1, selling_plan:config.plan, properties:{'Condizioni VIP':config.recurring}}]});
          }
        } else {
          await removePendingMembership(cart);
        }
        await renderCart();
      } catch (failure) {
        vip.checked = !selectedVip;
        syncPrices();
        status.textContent = failure.message;
      } finally {setBusy(false);}
    });
  });
  form?.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy) return;
    setBusy(true);
    const error = document.querySelector('#bc-error');
    error.textContent = '';
    try {
      await pending;
      const cart = await request('cart.js');
      if (!vip.checked && !member) await removePendingMembership(cart);
      const data = new FormData(form);
      const properties = Object.fromEntries(Array.from(data.entries()).filter(([key]) => key.startsWith('properties[')).map(([key, value]) => [key.slice(11,-1), value]));
      const items = [{id:Number(data.get('id')), quantity:Number(data.get('quantity')) || 1, properties}];
      if (vip.checked && !member && !cart.items.some(membership)) items.push({id:config.variant, quantity:1, selling_plan:config.plan, properties:{'Condizioni VIP':config.recurring}});
      await request('cart/add.js', {items});
      await renderCart();
      dialog.showModal();
    } catch (failure) {error.textContent = failure.message;} finally {setBusy(false);}
  });
  if (vip) {
    syncPrices();
    request('cart.js').then(cart => {if (!vipTouched && cart.items.some(membership)) {vip.checked = true; syncPrices();}}).catch(() => {});
  }
document.querySelectorAll('.bc-thumb').forEach((b,i)=>b.addEventListener('click',()=>{document.querySelector('#bc-hero').src=b.dataset.image+'&width=1000';document.querySelector('#bc-image-index').textContent=i+1}));document.querySelectorAll('video:not(.bc-simple-media)').forEach(v=>{v.controls=true;v.preload='none';v.addEventListener('play',()=>document.querySelectorAll('video').forEach(other=>{if(other!==v)other.pause()}))});document.querySelectorAll('.video-card').forEach(card=>card.querySelector('button')?.addEventListener('click',()=>card.querySelector('video')?.play()));document.querySelectorAll('button').forEach(b=>{const label=b.getAttribute('aria-label')||b.textContent.trim();if(label==='+'||label==='×'){b.addEventListener('click',()=>{const card=b.closest('.ingredient-card')||b.parentElement;card.classList.toggle('active');card.classList.toggle('flipped')})}if(/successivo|successiva|precedente|Scroll (left|right)/i.test(label)){b.addEventListener('click',()=>{const parent=b.closest('section')||b.parentElement;const track=parent.querySelector('ul,[class*=track],[class*=carousel]');if(track)track.scrollBy({left:(/precedente|left/i.test(label)?-1:1)*track.clientWidth*.8,behavior:'smooth'})})}})
})();
